import BidderDialog from "./BidderDialog";
import { json, useRouteLoaderData } from "react-router-dom";
import { get, patch } from "../../apiClient";
import createFormErrors from "../../utils/createFormErrors";

export async function loader({ params, request }) {
  try {
    const bidder = await get("player", `/api/programmatic_supply/bidders/${params.id}`, {
      signal: request.signal
    });

    return json(bidder);
  } catch(error) {
    throw new json({ title: "request failed", text: "Failed to process request" }, { status: 500 })
  }
}

export async function action({ params, request }) {
  const formData = await request.formData();

  try {
    await patch(
      "player",
      `/api/programmatic_supply/bidders/${params.id}`,
      {
        name: formData.get("name"),
        url: formData.get("url"),
        active: formData.get("active") === "true" ? true : false,
      },
      { signal: request.signal }
    );

    return json({ success: true });
  } catch (error) {
    switch (error.status) {
      case 422:
        return json(
          { errors: createFormErrors(error.details.errors) },
          { status: 422 }
        );
      /* istanbul ignore next */
      default:
        throw error;
    }
  }
}

const EditBidder = () => {
  const bidder = useRouteLoaderData("bidderLoader");

  return (
    <BidderDialog isEditing={true} bidder={bidder} />
  )
}

export default EditBidder;
